import React from "react";

export const useAutoComplete = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const onHandleOpenChange = (value) => {
    setIsOpen(value);
  };

  return {
    isOpen,
    onHandleOpenChange,
  };
};
